import React from "react";
import { Outlet } from "react-router-dom";
import { MobileNavigation } from "./MobileNavigation";
import { DesktopNavigation } from "./DesktopNavigation";
import { Toaster } from "sonner";
import { PwaOfflineReadyToast } from "@/features/pwa/components/PwaOfflineReadyToast/PwaOfflineReadyToast";
import { PwaInstallPrompt } from "@/features/pwa/components/PwaInstallPrompt/PwaInstallPrompt";

export const AppLayout: React.FC = () => {
  return (
    <div className="relative flex min-h-dvh flex-col bg-background bg-radial">
      <div className="flex h-full sm:h-dvh sm:overflow-hidden">
        <Toaster richColors position="top-right" />
        {/* PWA: install banner (bottom) and offline-ready toast (uses sonner Toaster above) */}
        <PwaOfflineReadyToast />
        <PwaInstallPrompt />
        <div className="flex h-full w-full gap-x-3 sm:p-4">
          {/* Sidebar - Desktop Navigation */}
          <DesktopNavigation />

          {/* Main Content Area */}
          <div className="flex-1 flex flex-col w-0 pb-[4.5rem] sm:pb-0">
            <main className="flex-1 relative focus:outline-none sm:overflow-auto">
              <div className="min-h-full">
                <div className="min-h-full bg-slate-800/50 backdrop-blur supports-[backdrop-filter]:bg-slate-800/50 rounded-lg border border-slate-700/50">
                  <Outlet />
                </div>
              </div>
            </main>
          </div>

          {/* Mobile Navigation - Shows at bottom on small screens */}
          <MobileNavigation />
        </div>
      </div>
    </div>
  );
};
